function pad(n) {
  return (n < 10 ? `0${n}` : n);
}

export { pad };
